var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19014_25109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4889 7.3125C14.4713 7.26562 13.9733 6.16406 12.8717 5.05664C11.401 3.5918 9.54358 2.8125 7.49866 2.8125C5.45374 2.8125 3.59632 3.5918 2.12561 5.05664C1.02405 6.16406 0.526003 7.26562 0.508425 7.3125C0.482265 7.37155 0.46875 7.43542 0.46875 7.5C0.46875 7.56458 0.482265 7.62845 0.508425 7.6875C0.526003 7.73438 1.02405 8.83594 2.12561 9.94336C3.59632 11.4082 5.45374 12.1875 7.49866 12.1875C9.54358 12.1875 11.401 11.4082 12.8717 9.94336C13.9733 8.83594 14.4713 7.73438 14.4889 7.6875C14.5151 7.62845 14.5286 7.56458 14.5286 7.5C14.5286 7.43542 14.5151 7.37155 14.4889 7.3125ZM7.49866 5.39062C7.91585 5.39062 8.32368 5.51434 8.67057 5.74612C9.01745 5.9779 9.28782 6.30734 9.44747 6.69278C9.60712 7.07822 9.6489 7.50234 9.5675 7.91152C9.48611 8.3207 9.28521 8.69655 8.99021 8.99155C8.69521 9.28655 8.31936 9.48745 7.91018 9.56884C7.501 9.65023 7.07687 9.60846 6.69144 9.44881C6.306 9.28915 5.97656 9.01879 5.74478 8.67191C5.513 8.32502 5.38928 7.91719 5.38928 7.5C5.38928 6.94056 5.61152 6.40403 6.00711 6.00845C6.40269 5.61286 6.93922 5.39062 7.49866 5.39062Z",
    fill: "#5F6063"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19014_25109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dbb0d3db5cc887f890bbb515241a35ca.svg";
export { ForwardRef as ReactComponent };